import { Helmet, Header, Table, AttachmentEditModal, AttachmentCreateModal } from 'components'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { useAuth } from 'hooks'
import { Service } from 'services'
import { EMAIL_ATTACHMENT_TABLE_COLUMNS } from 'constants/tables'
import { message, Modal, Button } from 'antd'

function AttachmentPage() {
    const { t } = useTranslation()
    const [isEditModalVisible, setIsEditModalVisible] = useState(false)
    const [isCreateModalVisible, setIsCreateModalVisible] = useState(false)
    const [selectedAttachment, setSelectedAttachment] = useState(null)
    const [attachments, setAttachments] = useState([])
    const [submitResult, setSubmitResult] = useState(null)
    const [deleteTarget, setDeleteTarget] = useState(null)

    const { isAuthenticated, renderAuthRequest } = useAuth()

    const handleEditOpenModal = attachmentData => {
        setSelectedAttachment(attachmentData)
        setIsEditModalVisible(true)
    }

    const handleCreateOpenModal = () => {
        setIsCreateModalVisible(true)
    }

    const handleDelete = attachmentData => {
        setDeleteTarget(attachmentData)
    }

    const confirmDelete = async () => {
        try {
            const result = await Service.delete.emailAttachment(deleteTarget.id)
            setSubmitResult(result)
            setDeleteTarget(null)
            message.success(t('general.feedback.delete.title'))
        } catch (err) {
            console.log(err)
            message.error(t('general.feedback.error.title'))
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await Service.list.emailAttachments()
                setAttachments(data)
            } catch (e) {
                console.error(e)
                setAttachments([])
            }
        }

        if (isAuthenticated === true) fetchData()
    }, [isAuthenticated, submitResult])

    if (!isAuthenticated)
        return (
            <div className='admin-page-login'>
                <Helmet title={t('page_titles.admin')} />
                <Header />
                {renderAuthRequest(t)}
            </div>
        )

    return (
        <div className='admin-page'>
            <Helmet title={t('page_titles.attachment')} />
            <Header
                title={t('attachment_page.title')}
                subtitle={t('attachment_page.subtitle')}
                homeLink
                dashLink
                type='dots'
            />

            {isEditModalVisible && (
                <AttachmentEditModal
                    baseValues={selectedAttachment}
                    visible={isEditModalVisible}
                    onClose={() => setIsEditModalVisible(false)}
                    onSubmit={result => setSubmitResult(result)}
                />
            )}

            {isCreateModalVisible && (
                <AttachmentCreateModal
                    visible={isCreateModalVisible}
                    onClose={() => setIsCreateModalVisible(false)}
                    onSubmit={result => setSubmitResult(result)}
                    nextPosition={
                        attachments.length > 0
                            ? Math.max(...attachments.map(a => a.position)) + 1
                            : 1
                    }
                />
            )}

            <Modal
                title={t('general.actions.delete')}
                visible={!!deleteTarget}
                onCancel={() => setDeleteTarget(null)}
                footer={[
                    <Button key='cancel' type='primary' onClick={() => setDeleteTarget(null)}>
                        {t('general.actions.cancel')}
                    </Button>,
                    <Button
                        key='delete'
                        onClick={confirmDelete}
                        style={{
                            backgroundColor: '#ff4d4f',
                            color: '#fff',
                            borderColor: '#ff4d4f',
                        }}
                    >
                        {t('general.actions.delete')}
                    </Button>,
                ]}
            >
                <p>{t('attachment_page.delete_confirm')}</p>
            </Modal>

            <Table
                title={t('attachment_page.table_title')}
                columns={EMAIL_ATTACHMENT_TABLE_COLUMNS(t, handleEditOpenModal, handleDelete)}
                data={attachments}
                pagination={false}
                createButton={true}
                hideExport
                handleCreate={handleCreateOpenModal}
            />
        </div>
    )
}

export default AttachmentPage
